import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        rightAlign: {
            textAlign: 'right',
        },
    }
})

export default useStyles
